import { ObjectDb } from './object.db';
import { FolderGridItemObject } from '@it2go/types';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FolderDb extends ObjectDb<FolderGridItemObject> {

    public tableName: string = 'folder';

    protected override columnMap = {
        name: 'name',
        personId: 'person.id',
        birthdateCelebration: null,
    };

    protected override joins = {
        person: 'person.id',
    };

    protected override indices = ['id', 'organizationId', 'serviceId'];

    protected gqlMethod = 'getFolders';

    protected syncFragment = `
        id
        person {
            id
        }
        status
        serviceId
        organizationId
    `;

}
